import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '../../utils/api-request';

interface CancelCollectionDeletionProps {
  collectionId: string;
}

export const cancelCollectionDeletion = async ({
  collectionId,
}: CancelCollectionDeletionProps) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId || !collectionId) {
    throw new Error('Organization ID, and collection name are required');
  }

  const response = await apiRequest({
    url: `/collections/${orgId}/${collectionId}`,
    method: 'PATCH',
    target: 'platform',
    body: {
      status: 'active',
    },
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to cancel collection deletion',
    };
  }

  return response;
};
